import React from 'react';
import { TextField } from '@material-ui/core'
import Button from 'components/Styled/Button/Button';

class JoinInvite extends React.Component {
    render() {

        const copy = ()=>{
            this.textField.select();
            document.execCommand("copy");

        }

        return (
            <div style={{display: 'flex'}}>
                <TextField 
                    inputRef={el => this.textField = el}
                    value={window.location.href} 
                    variant="filled" 
                    aria-readonly 
                    style={{
                        flex: '1 1 80%'
                    }} 
                />
                <Button 
                    onClick={copy}
                    color='secondary'
                    customstyle={{flex: '1 1 10%', margin: 0}}
                >
                    Copier
                </Button>
            </div>
        );
    }
}

export default JoinInvite;